import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { MaterialIcon } from 'shared/ui/MaterialIcon';

interface EventDetailsCellWithCsvColumn {
  entityId: number;
  csvDownloader: (entityId: number) => {
    isLoading: boolean;
    download: (paramsForUrl?: Record<string, string> | undefined) => Promise<void>;
  };
  className?: string;
}
export function EventDetailsCellWithCsvColumn({ csvDownloader, className, entityId }: EventDetailsCellWithCsvColumn) {
  const useDownloadCsvQuery = csvDownloader(entityId);

  return (
    <td className={className}>
      <MaterialIcon
        className="text-[20px] text-slate-300 hover:text-deep-blue-500"
        onClick={useDownloadCsvQuery.download as unknown as (event: React.MouseEvent<HTMLElement>) => void}
        attributes={getDataAutoTestAttributes(['history-csv-download']).attributes}
      >
        file_download
      </MaterialIcon>
    </td>
  );
}
